<div
    #chartContainer
    class="agpr-chart agpr-dataListChart"
    [agprLoading]="loading"
    [ngClass]="{'agpr-dataListChart-responsive' : responsive,
        'agpr-dataListChart-loading' : loading}"
>
    <agpr-scroll-panel>
        <ul
            *ngIf="data && !this.error"
            class="agpr-dataListChart-list"
            [ngStyle]="{ height: forceBlockHeight ? this.forceBlockHeight - this.hasHeader + 'px' : '100%' }"
        >
            <li
                *ngFor="let row of data; let i = index"
                class="agpr-dataListChart-item"
            >
                <span
                    class="agpr-dataListChart-itemBar"
                    [style.background]="colors && colors[row.id] ? colors[row.id] :
                        colors && colors['metric' + i] ? colors['metric' + i] :
                        chartOptions.defaultColors['color'+ (i + 1)]"
                ></span>
                <div [class]="'agpr-dataListChart-itemContent' + (skinny && (row.xValueDeltaPercent || row.xValueDeltaPercent === 0)? ' agpr-dataListChart-itemContent--skinny' : '')">
                    <span
                        [class]="'agpr-dataListChart-itemLabel' + (skinny && (row.xValueDeltaPercent || row.xValueDeltaPercent === 0) ? ' agpr-dataListChart-itemLabel--skinny' : '')"
                        [attr.id]="id ? (id + '.dataListChart.itemLabel.' + i) : null"
                    >
                        {{ row.label }}
                    </span>
                    <div [class]="'agpr-dataListChart-itemValueRow' + (skinny && (row.xValueDeltaPercent || row.xValueDeltaPercent === 0) ? ' agpr-dataListChart-itemValueRow--skinny' : '')">
                        <div class="agpr-dataListChart-itemValue">
                            <ng-container *ngIf="row.currency">
                                <ng-container *ngIf="row.useSignificantDigits">
                                    <!--
                                        Using currency and significant digits changes from the base functionality of currency
                                            - localization changes won't take affect (USD vs CAD vs YEN)
                                            - Because it only shows a maximum of 5 digits, there will be no comma separated groups
                                            - CurrencyCode might not be set on old data, ignore if not set
                                    -->
                                    {{ (row.xValue === undefined || row.xValue === null) ? 0 : row.xValue | significantDigits : 1 }}
                                </ng-container>
                                <ng-container *ngIf="!row.useSignificantDigits">
                                    {{ (row.xValue === undefined || row.xValue === null) ? 0 : row.xValue }}
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="row.numberFormat">
                                <!--
                                    Using numberFormat and significant digits changes from the base functionality of numberFormat
                                        - The numberFormat will be ignored, and significant digits will take precedence
                                -->
                                <ng-container *ngIf="row.useSignificantDigits">
                                    {{ (row.xValue === undefined || row.xValue === null) ? 0 : (row.xValue | significantDigits : 1) + (row.unit ? row.unit : '') }}
                                </ng-container>
                                <ng-container *ngIf="!row.useSignificantDigits && !row.abbreviatedValue">
                                    {{ (row.xValue === undefined || row.xValue === null) ? 0 : (row.xValue | number:row.numberFormat) + (row.unit ? row.unit : '') }}
                                </ng-container>
                                <ng-container *ngIf="row.abbreviatedValue">
                                    {{ row.abbreviatedValue }}
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="row.dateFormat">
                                {{ (row.xValue === undefined || row.xValue === null) ? 'Not Available' : (row.xValue | date:row.dateFormat) }}
                            </ng-container>
                            <ng-container *ngIf="!row.currency && !row.numberFormat && !row.dateFormat">
                                {{ (row.xValue === undefined || row.xValue === null) ? 0 : row.xValue }}
                            </ng-container>
                        </div>
                        <div
                            *ngIf="row.xValueDeltaPercent || row.xValueDeltaPercent === 0"
                            class="agpr-dataListChart-bubble"
                            [ngClass]="{
                                'agpr-dataListChart-bubbleRed': row.xValueDeltaPercent < 0,
                                'agpr-dataListChart-bubbleBlue': row.xValueDeltaPercent > 0,
                                'agpr-dataListChart-bubbleGrey': row.xValueDeltaPercent === 0
                            }"
                            [agprTooltip]="row?.previousPeriodTooltip"
                            role="img"
                        >
                            <i
                                class="fa-solid agpr-dataListChart-bubbleArrow"
                                [ngClass]="{
                                    'fa-arrow-down-right': row.xValueDeltaPercent < 0,
                                    'fa-arrow-up-right': row.xValueDeltaPercent > 0,
                                    'fa-hyphen': row.xValueDeltaPercent === 0
                                }"
                            ></i>
                            <span *ngIf="row.xValueDeltaPercent" aria-hidden="true">{{ row.xValueDeltaPercent | significantDigits }}%</span>
                        </div>
                    </div>
                </div>

            </li>
        </ul>
    </agpr-scroll-panel>
    <div
        *ngIf="error"
        class="agpr-dataListChart-error"
    >
        {{ error.message | localize}}
    </div>
</div>
